const state = {
  user: {},
  isLoggedIn: false,
};

export default state;
